'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.openModal = openModal;
exports.closeModal = closeModal;

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var OPEN = '@@Modal/Open';
var CLOSE = '@@Modal/Close';

var initialState = [];

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {
		case OPEN:
			var w = {
				id: _uuid2['default'].v4(),
				modal: action.modal
			};
			state.push(w);
			return [].concat(state);

		case CLOSE:
			state = state.filter(function (item) {
				return action.modal != item.modal;
			});
			return [].concat(state);

		default:
			return state;
	}
}

function openModal(modal) {
	return {
		type: OPEN,
		modal: modal
	};
}

function closeModal(modal) {
	return {
		type: CLOSE,
		modal: modal
	};
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-modal/src/reducer.js
 ** module id = 508
 ** module chunks = 1
 **/